import React from 'react';

const PlusIcon = ({ fill = "#052127", className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 1.375C6.3452 1.375 6.625 1.65482 6.625 2V5.375H10C10.3452 5.375 10.625 5.6548 10.625 6C10.625 6.3452 10.3452 6.625 10 6.625H6.625V10C6.625 10.3452 6.3452 10.625 6 10.625C5.6548 10.625 5.375 10.3452 5.375 10V6.625H2C1.65482 6.625 1.375 6.3452 1.375 6C1.375 5.6548 1.65482 5.375 2 5.375H5.375V2C5.375 1.65482 5.6548 1.375 6 1.375Z",
      fill
    }
  )
);
PlusIcon.displayName = "Icons.PlusIcon";

export { PlusIcon };
//# sourceMappingURL=PlusIcon.js.map
